import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-6 px-4 border-t border-white/10" data-id="element-66">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-67">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-3 py-1 rounded-full mb-3 text-[10px] tracking-widest" data-id="element-68">
          🏐 KIT COMPLETO VÓLEY LISTO
        </div>

        <p className="text-xs md:text-sm font-medium mb-2 max-w-xl text-gray-400 leading-relaxed" data-id="element-69">
          El sistema de planificación más completo para entrenadores de vóley
          del mundo hispanohablante. De México a Argentina. De Colombia a Chile.
          De Guatemala a Uruguay.
        </p>

        <p className="text-[10px] mb-4 text-gray-500 font-medium leading-relaxed" data-id="element-70">
          Principiantes, intermedios y avanzados. Diseñado para funcionar en
          cualquier país donde se hable español. Porque enseñar vóley bien no
          debería costarte todos los fines de semana del año.
        </p>

        <div className="w-full border-t border-white/5 pt-4 text-[10px] text-gray-600 font-medium" data-id="element-71">
          <p data-id="element-72">© Kit Completo Vóley Listo — Todos los derechos reservados</p>
        </div>
      </div>
    </footer>;
}